import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule as AngularFormModule } from '@angular/forms';
import {
    FormsBuilderModule,
    LayoutModule,
    IconsModule,
    DialogModule,
} from '@monsido/angular-shared-components';
import { FormBackendAdminCustomerPlanComponent } from './plan.component';
import { TranslateModule } from 'app/modules/translate.module';

@NgModule({
    imports: [CommonModule, AngularFormModule, IconsModule, LayoutModule, TranslateModule, FormsBuilderModule, DialogModule],
    exports: [FormBackendAdminCustomerPlanComponent],
    declarations: [FormBackendAdminCustomerPlanComponent],
    providers: [],
})
export class PlanModule {}
